/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateUserData = {
    /**
     * First name of the user.
     */
    firstName: string;
    /**
     * Last name of the user.
     */
    lastName: string;
    /**
     * Gender of the user.
     */
    gender: CreateUserData.gender;
    /**
     * Doctor of the user.
     */
    doctor?: string;
};
export namespace CreateUserData {
    /**
     * Gender of the user.
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        UNKNOWN = 'UNKNOWN',
    }
}

